'use strict';

var util = require('../util/util');

var cache = {};
var nonceCount = 0;

function showAjaxCallError() {
    var $balance = $('.giftCard-balance');
    var $form = $('#giftcard-check-balance');
    var ajaxError = $form.data('ajax-error');

    $balance.html(ajaxError).removeClass('success').addClass('error');
}

function setupNonceCall() {
    var nonceUrl = $('.custom-radio').data('url');
    $.ajax({
        url: nonceUrl,
        type: 'POST',
        contentType: 'application/json',
        success: function (data) {
            if (data.nonce) {
                Radial.setup(data.nonce, data.jwt); //eslint-disable-line
            }
        },
        error: function () {
            showAjaxCallError();
        }
    });
}

function tokenization() {
    var cardNumber=$('#giftcard-number').val().replace(/\s/g, '');
    $.spinner().start();
    Radial.tokenize(cardNumber, tokenizationCallbackHandler); //eslint-disable-line
}

function tokenizationCallbackHandler(data) {
    var errorCodes = [];
    switch (data.ActionCode) {
        case 'SUCCESS':
            nonceCount = 0;
            $.spinner().stop();
            $('#cardEncryptedValue').val(data.account_token);
            $('.card-number-wrapper .form-control').removeClass('is-invalid');
            break;
        case 'FAILURE':
            nonceCount = 0;
            $.spinner().stop();
            $('#cardEncryptedValue').val('');
            errorCodes = ['40001', '40002', '40003', '40004', '40006'];
            if (errorCodes.indexOf(data.failure_code) > -1) {
                $('.card-number-wrapper .invalid-feedback').html($('.card-number-wrapper #cardNumber').attr('data-bbw-custom-validate-card-error'));
                $('.card-number-wrapper .invalid-feedback').css('display', 'block');
            } else {
                $('.card-number-wrapper .invalid-feedback').html($('.card-number-wrapper #cardNumber').attr('data-bbw-custom-invalid-error'));
                $('.card-number-wrapper .invalid-feedback').css('display', 'block');
            }
            break;
        case 'ERROR':
            var nonceFailureRetryAttempt = $('.nonceFailureRetryAttempt').val();
            $('#cardEncryptedValue').val('');
            errorCodes = ['50001', '50002', '50003'];
            if (errorCodes.indexOf(data.error_code) > -1 && nonceCount < nonceFailureRetryAttempt) {
                nonceCount++;
                retryNonceTokenization();
            } else {
                nonceCount = 0;
                $.spinner().stop();
                $('.card-number-wrapper .invalid-feedback').html($('.card-number-wrapper #cardNumber').attr('data-bbw-custom-invalid-error'));
                $('.card-number-wrapper .invalid-feedback').css('display', 'block');
            }
            break;
    }
}

function retryNonceTokenization() {
    setupNonceCall();
    tokenization();
}

function getGiftCardParams() {
    return {
        giftCardNumber : $('#cardEncryptedValue').val(),
        giftCardPin : $('#giftcard-pin').val()
    };
}

function selectCCPaymentMethod() {
    $('.billing-nav.payment-information .payment-options').css('pointer-events', 'auto');
    $('.credit-card-content, .credit-card-tab').addClass('active').attr('aria-selected', 'true');
    $('.giftcard-content').removeClass('active');
    $('#selectedPaymentOption').val('CREDIT_CARD');
    $('.payment-information').data('payment-method-id', 'CREDIT_CARD');
}

module.exports = {
    setupNonce: function () {
        setupNonceCall();
    },

    initCache: function () {
        cache.$gcBalanceContent = $('#bbw-check-balance');
    },
    toggleIfParam: function () {
        var openCheckBalance = util.getUrlParameter('openCheckBalance');

        if (openCheckBalance) {
            cache.$gcBalanceContent.collapse('show');
        }
    },
    deleteAllGiftCards: function () {
        var url = $('.deleteAllGiftCards').val();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    $('.redemption-giftcard').html(data.renderedGiftCertHtml);
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer
                        }
                    );
                    selectCCPaymentMethod();
                }
            }
        });
    },
    tokenizeInitialization: function () {
        $('#giftcard-number').on('focusout', function (event) { // eslint-disable-line
            var cardNumber = $('#giftcard-number').val().replace(/\s/g, '');
            if (cardNumber == '') {
                return;
            }
            tokenization();
        });
    },
    checkBalance: function () {
        $('#giftcard-check-balance').submit(function (e) {
            e.preventDefault();
            var $balance = $('.giftCard-balance');
            var $form = $(this);
            var url = $form.attr('action');

            $.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: getGiftCardParams(),
                success: function (data) {
                    if (data.error) {
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        }
                        $balance.html(data.errorMessage).removeClass('success').addClass('error');
                        $.spinner().stop();
                        return;
                    }
                    $balance.html(data.giftCard.balance).removeClass('error').addClass('success');
                    $('#giftcard-number').val('');
                    $('#giftcard-pin').val('');
                    $.spinner().stop();
                },
                error: function () {
                    showAjaxCallError();
                    $.spinner().stop();
                }
            });
        });
    },

};
